import React from 'react';

export default function SoundIcon(props) {
    return (
        <svg width='28' height='28' viewBox='0 0 28 28' {...props}>
            <path
                fill='#1D1D1B'
                fillRule='nonzero'
                d='M14.203 8.235v11.251l-3.234-2.248h-.362c-1.765 0-3.195-1.443-3.195-3.223v-.308c0-1.78 1.43-3.224 3.195-3.224h.362l3.234-2.248zm4.87.406l.103.243a12.647 12.647 0 0 1 1.007 4.962c0 1.738-.35 3.428-1.02 4.992l-.104.243-1.207-.713.077-.185c.566-1.363.862-2.83.862-4.337 0-1.497-.291-2.953-.85-4.307l-.076-.185 1.207-.713zM16.62 10.06l.095.257c.415 1.118.63 2.308.63 3.528 0 1.232-.22 2.434-.642 3.56l-.096.257-1.188-.716.064-.18c.33-.929.5-1.913.5-2.921 0-.996-.166-1.97-.488-2.887l-.063-.18 1.188-.718z'
            />
        </svg>
    );
}
